/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Grundantragerhalten1Inputs */

const de__field_grundantragerhalten1 = /** @type {(inputs: _Field_Grundantragerhalten1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grundantrag erhalten`)
};

/**

* @param {_Field_Grundantragerhalten1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_grundantragerhalten1 = /** @type {((inputs?: _Field_Grundantragerhalten1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Grundantragerhalten1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_grundantragerhalten1(inputs)
});
export { _field_grundantragerhalten1 as "_field_grundantragErhalten" }